import { AsyncPipe } from '@angular/common';
import { Component, inject, input } from '@angular/core';
import { CollapseViewportWidth, DateRangePresetPeriod, GalaxyDatepickerModule } from '@vendasta/galaxy/datepicker';
import { DateRange } from '@vendasta/galaxy/utility/date-utils';
import { LocationsService } from '../locations';
import { AvailableTimeRangeOptions, TimeRangeService } from './time-range.service';
import { first, map, Observable } from 'rxjs';
import { filterNullAndUndefined } from '@vendasta/rx-utils';

@Component({
  selector: 'bc-time-range-picker',
  templateUrl: './time-range-picker.component.html',
  imports: [AsyncPipe, GalaxyDatepickerModule],
})
export class TimeRangePickerComponent {
  collapseViewportWidth = input<CollapseViewportWidth>('desktop-small');

  public readonly locationsService = inject(LocationsService);
  private readonly timeRangeService = inject(TimeRangeService);

  protected dateRangeSelected: DateRange;
  protected readonly defaultDatePeriod$: Observable<DateRangePresetPeriod> =
    this.timeRangeService.selectedTimeRangeOption$.pipe(
      map((r) => r.glxyKey),
      filterNullAndUndefined(),
      first(),
    );

  defaultCustomDateRange$ = this.timeRangeService.selectedTimeRangeOption$.pipe(
    map((r) => {
      return { start: r.dateRange[0], end: r.dateRange[1] };
    }),
  );

  onDateChange(value: DateRange): void {
    this.dateRangeSelected = value;
  }

  onPeriodChange(period: DateRangePresetPeriod): void {
    const timeRangeKey = AvailableTimeRangeOptions.find((type) => type.glxyKey === period)?.key;
    if (
      [DateRangePresetPeriod.custom, DateRangePresetPeriod.byMonth, DateRangePresetPeriod.byQuarter].some(
        (v) => v === period,
      )
    ) {
      this.timeRangeService.setDateRange([this.dateRangeSelected.start, this.dateRangeSelected.end], timeRangeKey);
    } else {
      this.timeRangeService.setTimeRange(timeRangeKey);
    }
  }
}
